import { times } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getPortfolioId } from "modules/portfolio-root/selectors/portfolios"
import { getItems } from "./selectors/items"
import { getPositionSet } from "helpers/comparison"
import { getDetailsItems, getDetailsData, getSmartTradeRiskData, getInstrumentPortfolio, getTableDownloadData } from "./selectors/details"
import { getSelectedGroup, getGroups } from "./selectors"
import { getMissingDataFiles, betasSubQuery } from "selectors/missingDataFiles"
import { classificationsQuery } from "helpers/classification"
import { getQueryGroupBy } from "helpers/rollups"
import { getAttributionMethod } from "modules/research-topic/selectors"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: (state, props) => ({
    portfolioUUID: getPortfolioId(state),
    selectedGroup: getSelectedGroup(state, props),
    missingDataFiles: getMissingDataFiles(state, props),
    attributionMethod: getAttributionMethod(state),
  }),
  required: ["account", "modelId", "positionSets", "selectedDate"],
  data: [...times(5, (n) => {
    return {
      resource: `compareTopicSummaryPositionSet${n}`,
      as: null,
      passthrough: n > 0,
      url: ({ modelId, positionSets, selectedDate, selectedGroup, missingDataFiles, attributionMethod }) => {
        if (!selectedDate || !positionSets[n] || positionSets[n].uploading || !missingDataFiles || !selectedGroup) {
          return null
        }

        const positionSet = getPositionSet(positionSets, n, selectedDate)
        const { groupBy, tier, groupById } = getQueryGroupBy(selectedGroup)

        return {
          id: `${modelId}${JSON.stringify(positionSet)}${selectedDate}${groupBy}${tier}${groupById}${attributionMethod}`,
          query: `query (
              $modelId: String!
              $positionSet: PositionSetInput! $from: Date!
              $to: Date!
              $groupBy: ContributorGroupType!
              $groupById: String
              $tier: String
              $attributionMethod: RiskContributorAttributionMethod
            ) {
            model (id: $modelId) {
              simulation (positionSet: $positionSet, from: $from, to: $to, interval: AUTO) {
                risk {
                  date
                  total
                  attribution {
                    summary {
                      factors
                      specific
                    }
                  }
                }
                riskContributors(attributionMethod: $attributionMethod){
                  id,
                  attribution{
                    summary {
                      specific
                    }
                  }
                }
                composition (scaleFormat: PERCENT_EQUITY_GMV) {
                  date
                  gmv
                  summaryStats {
                    average {
                      marketCapitalization
                    }
                  }
                  longShortComposition: compositionBy (groupBy: LONG_SHORT) {
                    id
                    description
                    economicExposure
                  }
                  compositionBy (groupBy: $groupBy, groupById: $groupById, classificationTier: $tier) {
                    id
                    description
                    economicExposure
                  }
                }
                ${betasSubQuery(missingDataFiles, ["date"])}
              }
            }
          }`,
          variables: {
            modelId,
            positionSet,
            from: selectedDate,
            to: selectedDate,
            groupBy,
            tier,
            groupById,
            attributionMethod,
          },
        }
      },
    }
  }),
  {
    resource: "classifications",
    as: null,
    url: () => {
      return {
        id: "classifications",
        query: classificationsQuery,
      }
    },
  },
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    items: getItems(state, props),
    detailsItems: getDetailsItems(state, props),
    detailsData: getDetailsData(state, props),
    smartTradeRiskData: getSmartTradeRiskData(state, props),
    groups: getGroups(state, props),
    instrumentPortfolio: getInstrumentPortfolio(state, props),
    tableDownloadData: getTableDownloadData(state, props),
  }),
  actions: {
    ...Creators,
  },
})
